import React from 'react'
import { Link } from 'react-router-dom'

export default class WelcomeIntroContainer extends React.Component {
  render() {
    return (
      <div className="screen welcome">
        <div className="navigation-bar">
          <div className="button-item left" onClick={this.props.onLogout}>
            Logout
          </div>
          <div className="title">Welcome to EL-FIT</div>
        </div>
        <div className="content-flex">
          <div style={{ flex: 1 }} />
          <img
            style={{ margin: 'auto', width: 293, height: 105 }}
            src={require('../images/setup_intro.png')}
            alt="poster"
          />
          <div style={{ flex: 1 }} />
          <p>Welcome to EL-FIT! Here’s how the program works:</p>
          <ul>
            <li>Connect your physical activity tracker (bracelet wearable).</li>
            <li>Watch exercise guidance videos and complete activities based on your condition.</li>
            <li>Track your progress against other study participants</li>
          </ul>
          <div style={{ flex: 1 }} />
          <Link to="/mobile/welcome/connect">
            <button className="black block">Next</button>
          </Link>
        </div>
      </div>
    )
  }
}
